module.exports = __webpack_public_path__ + "img/logo(7).a438aab2.svg";